function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { sdkLogger } from '../logger';
import { JsonUtils } from '../utils/json-utils';
export var LogVerbose = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return function LogVerbose(target, propertyName, descriptor) {
        try {
            var originalDescriptor = descriptor.value;
            var ctxName = name || target.constructor.name;
            if (typeof originalDescriptor !== 'function') {
                throw new Error("Target member must be a function");
            }
            descriptor.value = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _sdkLogger;
                (_sdkLogger = sdkLogger).verbose.apply(_sdkLogger, [
                    "Called ".concat(ctxName, ".").concat(propertyName, ":")
                ].concat(_to_consumable_array(args.map(JsonUtils.stringify))));
                return originalDescriptor.apply(this, args);
            };
        } catch (e) {
            sdkLogger.warn('LogVerbose decorator error on property: "'.concat(propertyName, '"'));
        }
        return descriptor;
    };
};

//# sourceMappingURL=log-verbose.js.map